import { all, call } from 'redux-saga/effects';

import accountSagas from './account/accountSagas';
import assetSagas from './asset/assetSagas';
import baremetalSagas from './baremetal/sagas';
import billingSagas from './billing/billingSagas';
import contactSagas from './contact/contactSagas';
import domainSagas from './domain/domainSagas';
import marketSagas from './market/sagas';
import monitoringSagas from './monitoring/monitoringSagas';
import networkSagas from './network/networkSagas';
import notificationsSagas from './notifications/notificationsSagas';
import productSagas from './product/productSagas';
import projectSagas from './project/projectSagas';
import serverSagas from './server/serverSagas';
import sslCertificateSagas from './ssl/certificate/sslCertificateSagas';
import storageSagas from './storage/storageSagas';
import stormSagas from './storm/stormSagas';
import supportSagas from './support/supportSagas';
import usertaskSagas from './usertask/usertaskSagas';
import utilitiesSagas from './utilities/utilitiesSagas';

export default function* apiRootSagas() {
	yield all([
		call(accountSagas),
		call(assetSagas),
		call(baremetalSagas),
		call(billingSagas),
		call(contactSagas),
		call(domainSagas),
		call(marketSagas),
		call(monitoringSagas),
		call(networkSagas),
		call(notificationsSagas),
		call(productSagas),
		call(projectSagas),
		call(serverSagas),
		call(sslCertificateSagas),
		call(storageSagas),
		call(stormSagas),
		call(supportSagas),
		call(usertaskSagas),
		call(utilitiesSagas),
	]);
}
